import React, { useMemo, useCallback, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import classnames from "classnames";
import {
  deleteSubUser,
  // getSubUsers,
  updateUserStatus
} from "services/usersServices";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import { Modal } from "reactstrap";
// import Select from "react-select";
import Loader from "components/Loader";
import AddUsers from "./../users/AddUsers";
import Pagination from "components/common/Pagination";
// import { Plus } from "react-feather";
import ConformationModalUser from "components/common/ConformationModalUser";
import { Switch } from "@mui/material";
import moment from "moment";
import { getAllUserMerchants } from "services/usersServices";
const { success, error, fetching } = NavigationActions;

let debounceTimer;

const HeaderComponent = props => {
  let classes = {
    "-sort-asc": props.isSortedDesc !== undefined && !props.isSortedDesc,
    "-sort-desc": props.isSortedDesc !== undefined && props.isSortedDesc
  };
  return <div className={classnames(classes)}>{props.title}</div>;
};

function UsersMerchantList(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageLength, setPageLength] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [sortObject, setSortObject] = useState({ id: "id", desc: false });
  const { token, success, error, fetching, user } = props;
  const [refresh, toggleRefresh] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState("0");
  // const [addLoader, setAddLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [addUserModal, showAddUserModal] = useState(false);
  const [deleteUserModal, showDeleteUserModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isEditRequest, setIsEditRequest] = useState(false);
  const [editUser, setEditUser] = useState({});
  const [warningModal, setWarningModal] = useState(false);

  // console.log(props.user, "Props user");

  // const pageOptions = [
  //   { value: 5, label: 5 },
  //   { value: 10, label: 10 },
  //   { value: 25, label: 25 },
  //   { value: 50, label: 50 },
  //   { value: 100, label: 100 },
  // ];

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Sr No."
            />
          );
        },
        placeholder: "",
        disableFilters: true,
        accessor: "id",

        Cell: tableInstance => {
          console.log(
            "check sr no",
            currentPage,
            tableInstance.row.index + 1 + currentPage * pageLength
          );
          return tableInstance.row.index + 1 + currentPage * pageLength;
        }
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Full Name"
            />
          );
        },
        placeholder: "Full Name",
        disableFilters: true,
        accessor: "name",
        Cell: tableInstance => (
          <span className="text-capitalize">
            {tableInstance.row.values.name}
          </span>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Email"
            />
          );
        },
        placeholder: "Email",
        disableFilters: true,
        accessor: "email"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Mobile No"
            />
          );
        },
        placeholder: "Mobile",
        disableFilters: true,
        accessor: "phone_number"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Date of Onboarding"
            />
          );
        },
        placeholder: "Date of onboarding",
        disableFilters: true,
        accessor: "createdAt",
        Cell: tableInstance => {
          return (
            <span className="text-capitalize">
              {moment(tableInstance.row.original.createdAt).format(
                "DD MMM YYYY"
              )}
            </span>
          );
        }
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Status"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "user_status",
        Cell: tableInstance => (
          <div className="react-action-class">
            <Switch
              checked={tableInstance.row.original.user_status}
              onChange={e => handleUpdateStatus(tableInstance.row.original)}
            />
          </div>
        )
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Action"
            />
          );
        },
        disableFilters: true,
        disableSort: true,
        accessor: "Action",
        Cell: tableInstance => (
          <div className="react-action-class">
            <button
              className="react-table-edit-button"
              onClick={() => {
                setIsEditRequest(true);
                setEditUser(tableInstance.row.original);
                showAddUserModal(true);
              }}
            >
              <i className="far fa-edit"></i>
            </button>
            <button
              className="react-table-delete-button"
              onClick={() => {
                setDeleteId(tableInstance.row.original._id);
                showDeleteUserModal(true);
                console.log(deleteUserModal, "deleteModal");
              }}
            >
              <i className="far fa-trash-alt"></i>
            </button>
          </div>
        )
      }
    ],
    [currentPage]
  );
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    rows,
    headerGroups,
    state: { sortBy }
  } = useTable(
    {
      data: usersList,
      columns: columns,
      manualSortBy: true,
      initialState: {
        pageSize: pageLength,
        pageIndex: 0
      }
    },
    useSortBy,
    usePagination
  );

  const callApi = useCallback(async () => {
    let params = {
      page_number: currentPage + 1,
      limit: pageLength || 10,
      sortBy: sortObject?.id,
      sortOrder:
        sortObject.desc !== undefined
          ? sortObject.desc
            ? "desc"
            : "asc"
          : "desc",
      search: searchText
    };
    await getAllUserMerchants(token, params).then(response => {
      if (response.success) {
        setUsersList(response.data.docs);
        setTotalRecords(response.data.totalDocs);
        setTotalPage(response.data.totalPages);
        setLoading(false);
        toggleRefresh(false);
      } else {
        error(response.message);
      }
    });
  });

  useEffect(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    debounceTimer = setTimeout(() => {
      callApi();
    }, 1000);
  }, [searchText]);

  useEffect(() => {
    // console.log("Use effect 1 called");
    refresh && callApi();
    // console.log("After statement 1");
  }, [refresh, currentPage, sortBy, pageLength]);

  useEffect(() => {
    // console.log("Use effect 2 called");
    setSortObject({ ...sortBy[0] });
    // console.log("After statement 2");
    toggleRefresh(true);
  }, [sortBy]);

  const handlePageChange = page => {
    console.log("page", page);
    fetching();
    setCurrentPage(page);
    toggleRefresh(true);
  };

  const closeAddModal = () => {
    showAddUserModal(false);
  };
  const handleUpdateStatus = async user => {
    console.log(user, "check1234");
    setLoading(true);
    let { user_status, _id } = user;
    await updateUserStatus(token, _id, { status: !user_status }).then(res => {
      if (res.success) {
        success(res.message);
        toggleRefresh(true);
        setLoading(false);
      } else {
        error(res.message);
        setLoading(false);
      }
    });
    setLoading(false);
  };
  const handleDeleteUser = async () => {
    let id = deleteId;
    setLoading(true);
    await deleteSubUser(token, id).then(response => {
      if (response.success) {
        success(response.message);
        toggleRefresh(true);
        showDeleteUserModal(false);
        setLoading(false);
      } else {
        showDeleteUserModal(false);
        error(response.message);
        setLoading(false);
      }
    });
  };

  const handleAddUser = e => {
    // console.log(e, "clicked");
    e.preventDefault();
    setIsEditRequest(false);
    // console.log("user", user);
    if (user?.subscription_package?.subscription_id || user.is_admin) {
      showAddUserModal(true);
    } else {
      setWarningModal(true);
    }
    // console.log("AddUser Modal", addUserModal);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row title-sec align-items-center">
          <div className="col-sm headline">Users</div>
          {/* <div className="col-sm-auto ml-auto"></div> */}
          <div className="col-auto ">
            {/* <button className="add-user-btn" onClick={handleAddUser}>
              Add Users <Plus height={"20px"}></Plus>
            </button> */}
          </div>
        </div>
        <div className="row align-items-center my-3">
          {/* <div className="col-auto">
            <label className="mr-2">Results :</label>
          </div> */}
          {/* <div className="pl-0" style={{ width: "200px" }}>
            <Select
              id="pagination"
              className="page-result"
              value={pageOptions.find(x => x.value === pageLength)}
              onChange={e => {
                setLoading(true);
                toggleRefresh(true);
                setPageLength(e.value);
              }}
              options={pageOptions}
            />
          </div> */}
          {/* <div className="col-7" style={{ marginLeft: "115px" }}></div> */}
          <div className="col-md-4">
            <div className="icon-form-control">
              <i class="fas fa-search"></i>
              <input
                value={searchText}
                onChange={e => {
                  setCurrentPage(0);
                  setSearchText(e.target.value);
                }}
                type="text"
                placeholder="Search users..."
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
        </div>
        <div className="div-container">
          <ReactTableWrapper {...props}>
            {/* <div className="row title-sec align-items-center">
              <div className="row title-sec align-items-center">
                <div className="col-sm headline"></div>
                <div className="col-sm-auto ml-auto">
                  {/* <input
                                  value={searchText}
                                  onChange={(e) =>
                                      setSearchText(e.target.value)
                                  }
                                  type="text"
                                  placeholder="Search.."
                                  className="fs-14 medium-text plr-10 form-control react-form-input"
                              /> */}
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
            <div className="table-responsive common-table card-box grey-box mb-2">
              <table className="table border-0" {...getTableProps()}>
                <thead className="thead-color text-center">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(header => (
                        <th
                          className="thead-color"
                          {...header.getHeaderProps(
                            header.getSortByToggleProps()
                          )}
                        >
                          <div>{header.render("Header")}</div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="text-center">
                  {loading ? (
                    <tr>
                      <td colSpan={4}>
                        <Loader colspan={columns?.length} />
                      </td>
                    </tr>
                  ) : rows.length > 0 ? (
                    rows.map(row => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <td className="td-border" {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="td-border" colSpan={columns?.length}>
                        <h6>No Data Found</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row align-items-center table-footer">
              <div className="col-sm-6 text-center text-sm-left">
                {/* {console.log(totalRecords, "check426")} */}
                <span className="total-entry">
                  Showing{" "}
                  {/* {totalRecords === 0 ? 0 : currentPage * pageLength + 1} to{" "} */}
                  {Math.min(
                    currentPage * pageLength + usersList.length,
                    totalRecords
                  )}{" "}
                  of {totalRecords} entries
                </span>
              </div>
              <div className="col-sm-6">
                <Pagination
                  onPageChange={handlePageChange}
                  // pages={Math.ceil(totalRecords / pageLength)}
                  page={currentPage}
                  pages={totalPage}
                  // onPageChange={gotoPage}
                  // pages={pageCount}
                  // page={pageIndex}
                />
              </div>
            </div>
          </ReactTableWrapper>
        </div>
      </div>
      {addUserModal ? (
        <Modal isOpen={addUserModal} backdrop={true} centered>
          <AddUsers
            closeAddModal={closeAddModal}
            refresh={() => toggleRefresh(true)}
            isEditRequest={isEditRequest}
            editUser={editUser}
            setEditRequest={() => setIsEditRequest(false)}
          />
        </Modal>
      ) : null}
      {deleteUserModal ? (
        <Modal isOpen={deleteUserModal} backdrop={true} centered>
          <ConformationModalUser
            isOpen={deleteUserModal}
            onClose={() => showDeleteUserModal(false)}
            confirmText={"Delete"}
            cancelBtnBsStyle=" modalcancelbutton btn-secondary"
            message={"Are you sure you want to delete this user?"}
            handleConfirm={() => handleDeleteUser()}
            modalPurpose={"delete"}
          />
        </Modal>
      ) : null}
      {warningModal ? (
        <Modal
          isOpen={warningModal}
          toggle={() => {
            setWarningModal(false);
            props.history.push("/admin/user-list");
          }}
          centered
        >
          <ConformationModalUser
            isOpen={warningModal}
            onClose={() => {
              setWarningModal(false);
              props.history.push("/admin/user-list");
            }}
            confirmText={"Subscribe"}
            cancelBtnBsStyle=" modalcancelbutton btn-secondary"
            message={"Please purchase subscription to add user"}
            handleConfirm={() => props.history.push("/subscription")}
            modalPurpose={"alert"}
          />
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(UsersMerchantList);
